import { ttlLink } from 'src/graphql/setup/config';

export const updateQueryWithInvalidation = (partnerId: number, includeDisabled = true) => () => {
  // The portal's ttlLink (packages/graphql-client/src/ttl-link.ts) serves fresh
  // cached data without hitting the network, so refetchQueries is a no-op for
  // queries that were just loaded. Mark the cached entry stale so the refetch
  // actually goes to the server. The cache key includes __partnerId, which the
  // tenantLink ahead of ttlLink injects into every operation's variables.
  ttlLink.invalidateQuery('GetPublicApiKeys', {
    partnerId,
    includeDisabled,
    __partnerId: String(partnerId),
  });
};
